'use client';

import { FC } from 'react';

export const GoogleLinksPreconnect: FC = () => {
  return (
    <>
      <link rel='preconnect' href='https://fonts.googleapis.com' />
      <link rel='preconnect' href='https://fonts.gstatic.com' crossOrigin='anonymous' />
    </>
  );
};
